<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>资料转发权限</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="add">
      <el-button type="primary" @click="addShow = true"
        >新增<i class="el-icon-upload el-icon--right"></i
      ></el-button>
    </div>
    <el-table :data="userData" style="width: 100%">
      <!-- <el-table-column label="用户 ID" prop="id"> </el-table-column> -->
      <el-table-column label="名称" prop="name"> </el-table-column>
      <el-table-column label="链接" prop="url"> </el-table-column>
      <el-table-column label="类型" prop="type"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <!-- <el-button type="success" size="mini" @click="oppen(scope.row)"
            >查看权限</el-button
          > -->
          <el-button size="mini" @click="handleEdit(scope.row)">修改</el-button>
          <el-button  size="mini" type="primary" @click="fenxiang(scope.row)"
            >分享</el-button
          >
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pagenum"
      :page-sizes="[1, 2, 5, 10]"
      :page-size="queryInfo.pagesize"
      layout="total, sizes, prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <!-- 添加链接 -->
    <el-dialog title="添加" :visible.sync="addShow">
      <el-form :model="addForm" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="url">
          <el-input v-model="addForm.url"></el-input>
        </el-form-item>
         <el-form-item label="是否控制">
           <el-switch
            v-model="addForm.is_shareable"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-form-item>
        <!-- <el-form-item label="分享次数" v-show="addForm.is_shareable ==true">
           <el-input v-model="addForm.share_count"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="submitAddForm('form')"
            >立即添加</el-button
          >
          <el-button @click="addShow = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 修改 -->
    <el-dialog title="修改" :visible.sync="editShow">
      <el-form :model="editFrom" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="editFrom.name"></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="url">
          <el-input v-model="editFrom.url"></el-input>
        </el-form-item>
        <el-form-item label="是否可分享">
           <el-switch
            v-model="editFrom.is_shareable"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitEditForm('form')"
            >立即修改</el-button
          >
          <el-button @click="editShow = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 分享 -->
    <el-dialog title="分享" :visible.sync="editShow1">
      <el-form :model="editFrom1" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="备注" prop="name">
          <el-input v-model="editFrom1.name"></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="url">
          <el-input v-model="editFrom1.url"></el-input>
        </el-form-item>
        <el-form-item label="截止时间">
          <!-- <span class="demonstration">{{ editFrom1.expired_time }}</span> -->
          <el-date-picker
            v-model="editFrom1.expired_time"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <template slot-scope="scope">
            <el-button type="primary" @click="fenxiang1(scope.row)"
              >确定</el-button
            >
            <el-button @click="editShow1 = false">取消</el-button>
          </template>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="分享链接" :visible.sync="dialogVisible" width="30%">
      <span>{{ url }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios1 from 'axios'
import Qs from 'qs'
export default {
  name: "role",
  data() {
    return {
      addShow: false,
      detailsShow: false,
      editShow: false,
      editShow1: false,
      showShow: false,
      dialogVisible: false,
      id: "",
      total: 0,
      // 获取用户列表的参数对象
      queryInfo: {
        query: "",
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10,
      },
      // 角色列表
      userData: [],
      // 权限列表
      powerList: [],
      // 权限目录
      optionsList: [],

      // 详情列表
      detailsList: [],

      rules: {
        type: [{ required: true, message: "请输入名称", trigger: "blur" }],
        url: [{ required: true, message: "请输入链接", trigger: "blur" }],
      },

      addForm: {
        name: "",
        url: "",
        is_shareable:false,
      },
      editFrom: {
        id: "",
        name: "",
        url: "",
        is_shareable:'',
        share_count:''
      },
      editFrom1: {
        url_id: "",
        url: "",
        name: "",
       
      },
      url: "",
    };
  },
  mounted: function () {
    this.getList();
  },
  methods: {
    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize;
      this.getList();
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.queryInfo.pagenum = newPage;
      this.getList();
    },
    
    getList() {
      this.$fetch(
        "/news/newsShareUrl/queryManagerListPage?status=2&pageSize=" +
          this.queryInfo.pagesize +
          "&currentPage=" +
          this.queryInfo.pagenum
      ).then((res) => {
        this.userData = res.data.rows;
        this.total = res.data.total;
        console.log("链接", this.userData);
      });
    },
    fenxiang(row) {
      this.editFrom1.url = row.url;
      this.editFrom1.url_id = row.id;
      if(row.is_shareable ==true){
         this.editFrom1.is_shareable  =false
      }else{
          this.editFrom1.is_shareable  =true
      }
      this.editFrom1.share_count = 1
      this.editShow1 = true;
    },
    fenxiang1() {
      this.$post("/news/newsShareUrlShared/insert", this.editFrom1).then(
        (res) => {
          if (res.code == 0) {
            let urldata = {
              // 机构端
              // weapp_id:"wx5e28c0c346aa4514",
              // weapp_secret:"16d99a568c06beff86e5f818b16e33c0",
              // 教付保
               weapp_id:"wx14913bd70f000eff",
              weapp_secret:"5e81b50b4682fbd557a915d9f5657aa6",
              weapp_url: this.editFrom1.url + "?id=" + res.data,
            };
            delete axios1.defaults.headers.token
            axios1({
              method:'POST',
              url: "https://cli.im/Home/Weapp/create",
              header: {
               'content-type': 'application/x-www-form-urlencoded'
              },
              data: Qs.stringify(urldata)
            }).then(
              (res1) => {
                console.log(res1.data);
                let data = {
                  id: res.data,
                  url: this.editFrom1.url + "?id=" + res.data,
                  qr_code: res1.data.data,
                };
                if (res1.data.status == 1) {
                  this.$post("/news/newsShareUrlShared/update", data).then(
                    (res2) => {
                      console.log(res2.data);
                      if (res2.code == 0) {
                        this.$message({
                          message: "分享成功",
                          type: "success",
                        });
                        this.editShow1 = false;
                        this.dialogVisible = true;
                      }
                    }
                  );
                }
                this.url = res1.data.data;
              }
            );
            // console.log(axios1)
          }
        }
      );
    },
    // 修改
    handleEdit(row) {
      this.editFrom.id = row.id;
      this.editFrom.name = row.name;
      this.editFrom.url = row.url;
      this.editFrom.is_shareable = row.is_shareable
      this.editShow = true;
    },
    // 删除
    handleDelete(row) {
      // 弹框询问用户是否直接删除数据
      let data = {};
      data.id = row.id;
      data.status = 1;
      this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$post("/news/newsShareUrl/update", data).then((res) => {
            if (res.code != 0) {
              return this.$message.error("删除角色失败!");
            } else {
              this.getList();
              return this.$message.success("删除角色成功!");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 添加
    submitAddForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!this.addForm.is_shareable){
            this.addForm.share_count = 999
          }else{
            this.addForm.share_count = 1
          }
          this.$post("/news/newsShareUrl/insert", this.addForm).then((res) => {
            console.log(res);
            if (res.code == 0) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.getList();
              this.addShow = false;
              this.addForm = {};
              this.addForm.is_shareable =false
            } else {
              this.$message({
                message: res.message,
              });
            }
          });
        } else {
          this.$message({
            message: "表单验证失败",
            type: "warning",
          });
          return false;
        }
      });
    },
    submitEditForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.editFrom);
          this.$post("/news/newsShareUrl/update", this.editFrom).then((res) => {
            console.log(res);

            if (res.code == 0) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.getList();
              this.editFrom.menuIds = [];
              this.editShow = false;
            } else {
              this.$message({
                message: res.message,
              });
            }
          });
        } else {
          this.$message({
            message: "表单验证失败",
            type: "warning",
          });
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style scoped>
.add {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/guanli/htmlRoot.vue